import React, { Component } from "react";
import { Table, Button, Message, Label } from "semantic-ui-react";

class ProjectsPrintReport extends Component {
  render() {

    const { transactions, total } = this.props;
    return (

      <Table celled fixed singleLine>
        <Table.Header>
        <Table.Row>
          <Table.HeaderCell colSpan="6" style={{ textAlign:"center" }}>Projects Report</Table.HeaderCell>
        </Table.Row>

          <Table.Row>
            <Table.HeaderCell width={1} style={{ textAlign: 'center' }}>Sr</Table.HeaderCell>
            <Table.HeaderCell width={5}>Company</Table.HeaderCell>
            <Table.HeaderCell width={4}>Project</Table.HeaderCell>
            <Table.HeaderCell width={2}>Mobile</Table.HeaderCell>
            <Table.HeaderCell width={2}>Code</Table.HeaderCell>
            <Table.HeaderCell width={2}>Status</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {transactions.map(transaction => (
            <Table.Row>
              <Table.Cell style={{ textAlign: 'center' }}>{transaction.sr}</Table.Cell>
              <Table.Cell>{transaction.company_name}</Table.Cell>
              <Table.Cell>{transaction.project_name}</Table.Cell>
              <Table.Cell>{transaction.mobile_tel}</Table.Cell>
              <Table.Cell>{transaction.project_code}</Table.Cell>
              <Table.Cell>{transaction.status}</Table.Cell>
            </Table.Row>
          )
          )}

          {/* <Table.Row>
              <Table.Cell style={{ textAlign:"center" }}></Table.Cell>
              <Table.Cell></Table.Cell>
              <Table.Cell style={{ textAlign:"center" }}></Table.Cell>
              <Table.Cell></Table.Cell>
              <Table.Cell colspan="3" style={{ textAlign:"left",fontSize:'15px' }}><b>{total}</b></Table.Cell>
             
            </Table.Row> */}

        </Table.Body>
      </Table>
    );
  }
}
export default ProjectsPrintReport;
